import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {RoleIds} from '@core/enums';
import {RouterLinks} from '@core/constants';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private router: Router) {
  }

  /**
   * navigates to start page
   */
  navigateToMain(userRoleId: number): void {
    if (!userRoleId && userRoleId !== 0) {
      this.router.navigate([RouterLinks.LOGIN]);
      return;
    }
    let route = RouterLinks.SCHEDULER;
    if (userRoleId === RoleIds.host) {
      route = RouterLinks.LOCATIONS;
    }

    if (userRoleId === RoleIds['manager host']) {
      route = RouterLinks.EVENTS;
    }

    if (userRoleId === RoleIds.manager) {
      route = RouterLinks.STAFF;
    }
    this.router.navigate([route]);
  }
}
